import { _any } from "i18n";

const DEFAULT_ERROR_KEY = "providerOperations.action.failed";

export function getProviderOperationsErrorMessage(errorJson: unknown): string {
	return _any(typeof errorJson === "string" && errorJson !== "" ? errorJson : DEFAULT_ERROR_KEY);
}
